import LoanDatatableFragments from 'features/drilldown/LoanDatatable/fragments';
import { PoolSummaryFragments } from 'features/loanPool/PoolSummary';
import useTableQueryParams from 'hooks/useTableQueryParams';

import { gql, useQuery } from '@apollo/client';

import { Filter, SortableField, SortDirection } from '__generated__/globalTypes';
import { GetPoolLoans, GetPoolLoansVariables } from './__generated__/getPoolLoans_gql';
export const GET_POOL_LOANS_QUERY = gql`
  query GetPoolLoans($poolId: ID!, $sort: Sort!, $pagination: Pagination!, $filters: [Filter!]) {
    user {
      id
      company {
        id
        pool(id: $poolId) {
          id
          loans(sort: $sort, pagination: $pagination, filters: $filters) {
            id
            ...LoanDatatableLoan
          }
          performance_summary(filters: $filters) {
            ...LoanDatatablePerformanceSummary
            ...PoolSummaryPerformanceSummary
          }
        }
      }
    }
  }
  ${LoanDatatableFragments.loan}
  ${LoanDatatableFragments.performanceSummary}
  ${PoolSummaryFragments.performanceSummary}
`;

export const usePoolLoans = (
  poolId: string | null,
  queryFilters: Filter[],
  loansSorting: { id: SortableField; desc: boolean }[],
) => {
  const { params, updateParams } = useTableQueryParams();

  const { data, loading, previousData } = useQuery<GetPoolLoans, GetPoolLoansVariables>(
    GET_POOL_LOANS_QUERY,
    {
      variables: {
        poolId: poolId!,
        sort: {
          sort_field: loansSorting[0]?.id,
          sort_direction: loansSorting[0]?.desc ? SortDirection.desc : SortDirection.asc,
        },
        pagination: {
          offset: (params.pageNumber - 1) * params.pageSize,
          page_size: params.pageSize,
        },
        filters: queryFilters,
      },
      skip: !poolId,
      fetchPolicy: 'no-cache',
    },
  );

  return {
    data,
    loading,
    previousData,
    params,
    updateParams,
  };
};
